import { useMemo } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import { useTranslation } from 'react-i18next';
import { Divider } from "@mui/material";
import colors from "../../../assets/theme/base/colors";
import UpaGrahaPopoverCell from "./UpaGrahaPopoverCell";

function BhavaUpaGrahaCell({ value, row, planetData }) {
    return (
        <UpaGrahaPopoverCell
            upaGraha={value}
            planetData={planetData}
            bhavaIndex={row?.original?.bhavaIndex}
        />
    );
}

BhavaUpaGrahaCell.propTypes = {
    value: PropTypes.any,
    row: PropTypes.object,
    planetData: PropTypes.array,
};

function BhavaDataView({ tableData, planetData }) {
    const { t } = useTranslation();

    const planetRows = useMemo(() => Array.isArray(planetData) ? planetData : [], [planetData]);

    const dataTableData = {
        columns: [
            { Header: t("Bhavaya"), accessor: "bhavaIndex" },
            { Header: t("Rashiya"), accessor: "rasi" },
            { Header: t("Place"), accessor: "place" },
            {
                Header: t("Nekatha"),
                accessor: "nekatha",
                cellSx: {
                    backgroundColor: colors.badgeColors.info.background,
                    //color: colors.badgeColors.warning.text,
                    fontWeight: 700,
                },
            },
            {
                Header: t("UpaGraha"),
                accessor: "upaGraha",
                cellSx: {
                    backgroundColor: colors.badgeColors.success.background,
                    //color: colors.badgeColors.info.text,
                    fontWeight: 700,
                },
                Cell: (props) => <BhavaUpaGrahaCell {...props} planetData={planetRows} />,
            },
            { Header: t("UpaUpaGraha"), accessor: "upaUpaGraha" },
            { Header: t("UpaUpaUpaGraha"), accessor: "upaUpaUpaGraha" },
            { Header: t("GahasInBhava"), accessor: "gahasInBhava" },
        ],
        rows: tableData
    }

    return (
        <MDBox pt={0} pb={1} id="planets-ref">
            <MDBox mb={1}>
                <Card>
                    {/* <MDBox p={3} lineHeight={1} mb={0} display="flex" alignItems="center">
                        <MDTypography variant="h5" fontWeight="medium">
                            ග්‍රහස්ථුට
                        </MDTypography>
                        <Divider variant="fullWidth" sx={{ flexGrow: 1, marginLeft: 2 }} />
                    </MDBox> */}
                    <DataTable
                        canSearch={false}
                        entriesPerPage={false}
                        showTotalEntries={false}
                        table={dataTableData} />
                </Card>
            </MDBox>
        </MDBox>
    );
};

BhavaDataView.propTypes = {
    tableData: PropTypes.any,
    planetData: PropTypes.any
};

export default BhavaDataView;